module.exports = __webpack_public_path__ + "img/mesa_el_k.f906e11a.png";